import styled from 'styled-components';

export const WrapperCalendar = styled.div`
  margin-right: 15px;
`;

export const Disclaimer = styled.div<{ disabled?: boolean }>`
  margin-top: 5px;
  text-align: left;
  margin-right: 40px;
  font-size: ${({ theme }) => theme.fontSize.C1};
  color: ${({ theme, disabled }) => (disabled ? theme.colors.gray900 : theme.colors.gray700)};
`;

export const Input = styled.input`
  width: 315px;
  height: 40px;
  padding: 0 20px;
  border-radius: 4px;
  border-width: 0;
  vertical-align: top;
  background-color: ${({ theme }) => theme.colors.white100};
  font-size: ${({ theme }) => theme.fontSize.B3};

  &[disabled] {
    background-color: ${({ theme }) => theme.colors.gray900};
    color: ${({ theme }) => theme.colors.gray800};
  }

  &::placeholder,
  &::-webkit-input-placeholder {
    color: ${({ theme }) => theme.colors.gray600};
  }

  &::-webkit-calendar-picker-indicator {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
`;
